export default function isReactNative() {
  return navigator.product === 'ReactNative';
}
